export const RoleType = Object.freeze({
  NORMAL: 0,
  ADMIN: 1,
  READ_ONLY: 2,
});
